<template>
 <div class="product-section-3 vi-container">
   <div class="main-container">
     <logo-header
       :logo-asset="amnium"
     />

     <lead-title1
       main-title="FASTEST WAY TO PRODUCTION"
       sub-title="READY HIGHLT CUSTOMIZABLE VIDEO APPS"
     />

     <info-section5/>
   </div>






 </div>
</template>

<script>
 import LogoHeader from "../components/LogoHeader";
 import LeadTitle1 from "../components/sideMenu/LeadTitle1";
 import ProductTab from "../components/productComponents/ProductTab";
 import InfoSection5 from "./InfoSection5";
 export default {
  name: 'ProductSection3',
   components: {InfoSection5, ProductTab, LeadTitle1, LogoHeader},
   data: () => ({
     amnium: require('../assets/logos/amnium-logo.png'),
   })

 }
</script>

<style lang="scss">
@import "ProductSection3.scss";
</style>
